var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiskusNewRoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 914.34,
    height: 914.34,
    viewBox: "0 0 914.34 914.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_472",
    "data-name": "Rectangle 472",
    width: 870,
    height: 870,
    transform: "translate(-2928 -18566)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_23",
    "data-name": "Mask Group 23",
    transform: "translate(3895.657 18432.851) rotate(-3)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1240",
    "data-name": "Group 1240",
    transform: "translate(-4150 -18967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M1721.459,230.449a16.464,16.464,0,0,1,32.927,0,233.829,233.829,0,0,1-116.659,202.192A16.49,16.49,0,0,1,1621.2,404.1a200.586,200.586,0,0,0,100.255-173.65Z",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, 633.459, 1984.281)",
    fill: "#6172d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M1858.99,364.591a332.781,332.781,0,0,1-440.985,129.049,51.068,51.068,0,0,0,16.191-28.7,299.972,299.972,0,0,0,396.255-116.878,16.491,16.491,0,0,1,28.54,16.53Z",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, 633.291, 2043.705)",
    fill: "#6172d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M1318.123,206.708a299,299,0,0,0,29.894,227.451,16.458,16.458,0,0,1-28.538,16.4,332.644,332.644,0,0,1,109.128-446.7,51.163,51.163,0,0,0,17.158,28.149A298.82,298.82,0,0,0,1318.123,206.708Z",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, 541.174, 2027.588)",
    fill: "#6172d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M1832.011-65.325a51.034,51.034,0,0,0-15.765,28.9,398.976,398.976,0,0,0-587.33,351.538,16.461,16.461,0,1,1-32.921,0A431.849,431.849,0,0,1,1832.011-65.325Z",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, 504.295, 2027.723)",
    fill: "#6172d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M1603.693,441.322a16.469,16.469,0,0,1-16.468,16.467,233.3,233.3,0,0,1-232.99-219.3,51.292,51.292,0,0,0,32.947-.766,200.439,200.439,0,0,0,200.043,187.143A16.466,16.466,0,0,1,1603.693,441.322Z",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, 602.469, 2043.16)",
    fill: "#6172d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M1968.6,272.789A431.844,431.844,0,0,1,1551.16,704.327a51.634,51.634,0,0,0-.025-32.959A398.9,398.9,0,0,0,1882.262,73.311a16.45,16.45,0,0,1,28.526-16.392A431.1,431.1,0,0,1,1968.6,272.789Z",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, 589.324, 1974.502)",
    fill: "#6172d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M1875.35,279.948a51.564,51.564,0,0,0-32.973-.113,299.455,299.455,0,0,0-299.3-284.59,16.473,16.473,0,0,1-16.454-16.467,16.471,16.471,0,0,1,16.454-16.455A332.287,332.287,0,0,1,1875.35,279.948Z",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, 567.365, 1967.727)",
    fill: "#6172d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M1776.6,146.627a51.046,51.046,0,0,0-28.576,16.58,200.457,200.457,0,0,0-340.272,11.28,16.485,16.485,0,0,1-28.526-16.53,233.532,233.532,0,0,1,397.373-11.33Z",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, 563.438, 2010.861)",
    fill: "#6172d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M1759.6-40.11a27.937,27.937,0,0,1-27.935,27.935,27.937,27.937,0,0,1-27.934-27.935,27.413,27.413,0,0,1,.411-4.774,27.829,27.829,0,0,1,8.6-15.763,27.818,27.818,0,0,1,18.927-7.391A27.93,27.93,0,0,1,1759.6-40.11Z",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, 585.547, 1925.455)",
    fill: "#4adede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M1731.974,168.47a27.934,27.934,0,0,1-55.869,0,27.438,27.438,0,0,1,.411-4.774,27.935,27.935,0,0,1,55.458,4.774Z",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, 626.98, 1960.799)",
    fill: "#4adede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M1823.758,254.47a27.935,27.935,0,0,1-55.87,0,27.508,27.508,0,0,1,.411-4.774,27.935,27.935,0,0,1,55.458,4.774Z",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, 658.252, 1953.082)",
    fill: "#4adede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M1465.975,3.122a27.935,27.935,0,1,1-55.869,0,27.472,27.472,0,0,1,.411-4.774,27.834,27.834,0,0,1,8.6-15.763,27.822,27.822,0,0,1,18.928-7.391A27.93,27.93,0,0,1,1465.975,3.122Z",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, 553.879, 1994.545)",
    fill: "#4adede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M1401.828,209.209a27.935,27.935,0,0,1-55.871,0,27.342,27.342,0,0,1,.412-4.774,27.935,27.935,0,0,1,55.458,4.774Z",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, 589.193, 2037.064)",
    fill: "#4adede"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiskusNewRoundIcon);
export default __webpack_public_path__ + "static/media/Diskus_newRoundIcon.07a83ed97f14147a318bd1722aab6a36.svg";
export { ForwardRef as ReactComponent };